var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16329 3.49854H4.66472C4.02066 3.49854 3.49854 4.02066 3.49854 4.66472V8.16329C3.49854 8.80736 4.02066 9.32948 4.66472 9.32948H8.16329C8.80736 9.32948 9.32948 8.80736 9.32948 8.16329V4.66472C9.32948 4.02066 8.80736 3.49854 8.16329 3.49854Z",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3239 3.49854H19.8254C19.1813 3.49854 18.6592 4.02066 18.6592 4.66472V8.16329C18.6592 8.80736 19.1813 9.32948 19.8254 9.32948H23.3239C23.968 9.32948 24.4901 8.80736 24.4901 8.16329V4.66472C24.4901 4.02066 23.968 3.49854 23.3239 3.49854Z",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16329 18.6591H4.66472C4.02066 18.6591 3.49854 19.1812 3.49854 19.8252V23.3238C3.49854 23.9679 4.02066 24.49 4.66472 24.49H8.16329C8.80736 24.49 9.32948 23.9679 9.32948 23.3238V19.8252C9.32948 19.1812 8.80736 18.6591 8.16329 18.6591Z",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4901 18.6591H20.9916C20.373 18.6591 19.7797 18.9048 19.3423 19.3422C18.9049 19.7796 18.6592 20.3728 18.6592 20.9914V24.49",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4897 24.49V24.5017",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.994 8.16333V11.6619C13.994 12.2805 13.7483 12.8737 13.3109 13.3111C12.8735 13.7485 12.2802 13.9943 11.6617 13.9943H8.16309",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49854 13.9943H3.5102",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 3.49854H14.0058",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 18.6591V18.6707",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6592 13.9943H19.8254",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4897 13.9943V14.0059",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 24.4899V23.3237",
    stroke: "white",
    strokeWidth: 2.33238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.679591d74a50580f3da1a6e3ede1dfb2.svg";
export { ForwardRef as ReactComponent };